import create, { SetState } from "zustand";

import { SurveyParticipantsStore } from "./model";

const surveyParticipantsStore = (set: SetState<SurveyParticipantsStore>) => ({
	surveyAccess: "all-employees" as const,
	editParticipants: false,
	temporarySelectionObjectId: null,
	setters: {
		setSurveyAccess: (surveyAccess: "all-employees" | "selected-employees") => set({ surveyAccess }),
		setEditParticipants: (editParticipants: boolean) => set({ editParticipants }),
		setTemporarySelectionObjectId: (temporarySelectionObjectId: string | null) =>
			set({ temporarySelectionObjectId }),
	},
	actions: {
		resetStore: () =>
			set({
				surveyAccess: "all-employees" as const,
				editParticipants: false,
				temporarySelectionObjectId: null,
			}),
	},
});

const useSurveyParticipantsStore = create<SurveyParticipantsStore>(surveyParticipantsStore);

export const useSurveyAccess = () => useSurveyParticipantsStore((state) => state.surveyAccess);
export const useEditParticipants = () => useSurveyParticipantsStore((state) => state.editParticipants);
export const useTemporarySelectionObjectId = () =>
	useSurveyParticipantsStore((state) => state.temporarySelectionObjectId);
export const useSetters = () => useSurveyParticipantsStore((state) => state.setters);
export const useActions = () => useSurveyParticipantsStore((state) => state.actions);
